module.exports = __webpack_public_path__ + "static/img/ship.3e122bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ship.jpg
// module id = S+k7
// module chunks = 1